import { updatePlanningShiftTableState } from '@/entities/gridTables/thunks/updatePlanningShiftTableState'
import { planningShiftsSelectors, StopTypeEnum } from '@/entities/schedules'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

import { ordersSelectors } from '../ordersSelectors'
import { fetchPlanningOrders } from './fetchPlanningOrders'

type FetchOrdersByShiftPayload = {
  shiftId: EntityId
  forceRefresh?: boolean
}

export const fetchPlanningOrdersByShift = createAsyncThunk<void, FetchOrdersByShiftPayload, ThunkApiContext>('orders/fetchPlanningOrdersByShift',
  async ({ shiftId, forceRefresh }, { dispatch, getState }) => {
    const state = getState()
    const planningShift = planningShiftsSelectors.selectById(state, shiftId)

    if (planningShift.loads && planningShift.loads.length > 0) {
      const orderIds = planningShift.loads
        .flatMap(load => load.stops.map(stop => stop.stopType === StopTypeEnum.Order ? stop.orderId : undefined))
        .filter((orderId) => orderId !== undefined)
        .filter((orderId) => forceRefresh ? true : (orderId && !ordersSelectors.selectById(state, orderId)))

      if (orderIds.length > 0) {
        await dispatch(fetchPlanningOrders({ orderIds }))
      }
    }

    // Update the planning shift table state
    await dispatch(updatePlanningShiftTableState({ shiftId }))
  },
)
